import { createEntityReducer } from "@selas/state-management";

import Endpoint from "../../services/api/endpoint";
import { IMessage } from "../../utils/types/models";

export default createEntityReducer<IMessage>(Endpoint.Messages);
